function randomstring(L: number) {
    var s = '';
    var randomchar = function() {
      var n = Math.floor(Math.random() * 62);
      if (n < 10) return n; //1-10
      if (n < 36) return String.fromCharCode(n + 55); //A-Z
      return String.fromCharCode(n + 61); //a-z
    }
    while (s.length < L) s += randomchar();
    return s;
  }

function isPageReloaded(){
  const performanceNavigation =window.performance.getEntries()[0] as PerformanceNavigationTiming
  console.info("[ADPClient] performanceNavigationType",performanceNavigation.type);
  if (performanceNavigation) {
    if(performanceNavigation.type=== "reload")
    return true;
    else return false;
 
  }
  else {
    return false;
  }
}  
function formatDate(date: Date,time=false){
  const d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  const year = d.getFullYear();
  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  if(time){
      const sec = d.getSeconds();
      const milisec = d.getMilliseconds();
      const hour = d.getHours();
      return [year, month, day,hour, sec, milisec].join('-');
  }
  else{
      return [year, month, day].join('-');
  }
    
}
function getEnvironment(){
  let loc = window.location.href.split(".")
  let env = loc.length > 1  ? loc[1] : "dev24";
  if (window.location.href.includes('127.0')){
      env = "dev24";
  }
 
  console.log(`[Config][get environmnet][current environment: ${env}]`);
  return env; 
}
function getDomain(){
  const location =window.location.origin;
  const currentPath = window.location.href.replace("index.html", "");
  const domain = location.includes('localhost') ? "http://localhost:3000/" : currentPath;
  return domain;
}
function getENAEPDomain(){
  const location =window.location.origin;
  const domain = location.includes('localhost') ? "https://enaep.dev24.npdng.org" : `${location}`;
  return domain;
}
function getApiDomain(){
  const hostname =window.location.hostname;
  const protocol = window.location.protocol
  const domain = hostname.includes('localhost') ? `https://api.enaep.dev24.npdng.org` : `${protocol}//api.${hostname}`;
  return domain;
}
function isLocalhost(){
  const hostname =window?.location.hostname;
 return hostname?.includes('localhost')
}
function resolveNCSDomain(){
  const urlParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlParams.entries());
  let apiUrl = params.lcs_api_url;
  return apiUrl ? apiUrl.split(":")[0] : false
}
function getQueryParams(){
  const params = new URL(window.location.href).searchParams
  return params;
}
function getPathName(){
  return window.location.pathname;
}
const environment={
  resovleAppDomain: getDomain,
  resolveApiDomain: getApiDomain,
  resolveENAEPDomain: getENAEPDomain
}


function sleep(ms:number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export {getEnvironment as getEnvironmnet,isLocalhost,randomstring,isPageReloaded,environment,sleep,formatDate,resolveNCSDomain,getQueryParams,getPathName};